import './Button.style.scss';
import { ButtonProps } from './Button.type';
import { getButtonClass } from './Button.util';

const Button = ({
  label,
  variant = 'primary',
  prefixIcon,
  suffixIcon,
  type = 'button',
  className,
  disabled,
  size,
  isIcon,
  ...rest
}: ButtonProps) => {
  const buttonClass = getButtonClass(variant, className, isIcon, size);

  if (isIcon) {
    return (
      <button className={buttonClass} type={type} disabled={disabled} {...rest}>
        {prefixIcon}
      </button>
    );
  }

  return (
    <button className={buttonClass} type={type} disabled={disabled} {...rest}>
      {prefixIcon && <span className="icon">{prefixIcon}</span>}
      <span>{label}</span>
      {suffixIcon && <span className="icon">{suffixIcon}</span>}
    </button>
  );
};

export default Button;
